import { ACCENT_GOLD } from '../lib/medievalTheme';
import { t } from '../localization/t';

/**
 * Small "BETA" stamp overlaid on the Valkenhall wordmark. Marks the build as a
 * public beta wherever the logo appears so players never mistake it for a
 * finished product.
 *
 * Drop inside a `position: relative` container; it sits in the wordmark's
 * lower-right, inset from the box corner so the logo's transparent padding
 * doesn't strand it in empty space. `scale` proportionally resizes the stamp
 * for logos that render larger or smaller than the main-menu wordmark (its
 * baseline of 1).
 */
export default function BetaBadge({ scale = 1, className = '', style }) {
  return (
    <span
      className={`absolute font-bold arena-heading select-none pointer-events-none ${className}`}
      style={{
        bottom: '6%',
        right: '4%',
        fontSize: `${0.6875 * scale}cqw`,
        lineHeight: 1,
        color: ACCENT_GOLD,
        background: '#100d0a',
        border: `1px solid ${ACCENT_GOLD}`,
        borderRadius: 'var(--radius-sm)',
        padding: `${0.16 * scale}cqw ${0.42 * scale}cqw`,
        boxShadow: '0 2px 6px rgba(0,0,0,0.6)',
        textShadow: '0 1px 2px rgba(0,0,0,0.7)',
        ...style,
      }}
    >
      {t('Beta')}
    </span>
  );
}
